import Empty from "@/components/Helpers/Empty";
import Aside from "@/components/Helpers/Aside";
import ProductCard from "@/components/Helpers/ProductCard";
import WishListReminder from "@/components/Profile/WishListReminder";
import Toast from "@/components/Toast/toast";
import { AppContext } from "@/contexts/appContexts";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { event_wishlist_viewed } from "@/utils/gtm";
import SEO from "@/components/seo";
import { favoriteMetadata } from "@/constants/metadata";

const Favourites = ({ isUser }) => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation("favourites");

  // Add to wishlist

  const { wishList } = useContext(AppContext);

  useEffect(() => {
    console.log("wishList", wishList);
    const skus = wishList?.map((item) => item?.sku)?.join(", ");
    const names = wishList?.flatMap((item) => item?.name)?.join(", ");
    const total = wishList?.reduce(
      (total, item) => total + item.prices_with_tax?.price,
      0
    );
    event_wishlist_viewed(
      wishList,
      wishList?.length,
      skus,
      names,
      0.85 * total,
      0.15 * total,
      total
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Reminder
  const [loginReminder, setloginReminder] = useState(!isUser);

  return (
    <>
      <SEO
        title={favoriteMetadata[`title-${locale}`]}
        description={favoriteMetadata[`description-${locale}`]}
      />
      <div
        className={`w-[80%] max-[570px]:w-[98%] mx-auto my-10 px-3 ${
          process.env.NEXT_PUBLIC_WEBSITE_MODE == "extreme" &&
          "bg-white p-2 rounded-md"
        }`}
      >
        <div className="grid grid-cols-12 gap-4">
          {isUser && (
            <div className="col-span-3 max-[991px]:col-span-full">
              <Aside />
            </div>
          )}
          <div
            className={`${
              isUser ? "col-span-9" : "col-span-full"
            } max-[991px]:col-span-full`}
          >
            {wishList?.length > 0 && (
              <div className="flex justify-between mb-6 max-[420px]:block max-[420px]:mb-0 ">
                <h1 className="text-xl font-semibold text-red">
                  {t("MyFavourites")}
                </h1>
              </div>
            )}
            {wishList?.length > 0 ? (
              <div className="grid grid-cols-4 gap-4 max-[1200px]:grid-cols-3 max-[768px]:grid-cols-2 max-[420px]:grid-cols-1">
                {wishList?.map((product, i) => (
                  <ProductCard fromFav product={product} key={i} t={t} />
                ))}
              </div>
            ) : (
              <Empty
                title={t("NoItems")}
                description={t("NoItemsDesc")}
                img="/svgs/no-fav.svg"
                titleClassName="!text-black max-md:!mt-5 max-sm:!text-2xl"
                descriptionClassName="max-md:!text-base"
                imgWrapperClassName="max-sm:!w-[205px] max-sm:!h-[184px] max-md:!w-[230px] max-md:!h-[220px]"
                fromFav
              />
            )}
          </div>
        </div>

        {loginReminder && (
          <WishListReminder t={t} setloginReminder={setloginReminder} />
        )}

        <Toast />
      </div>
    </>
  );
};

export default Favourites;

export async function getServerSideProps(ctx) {
  const { mage } = ctx.req.cookies;
  let isUser;
  if (!mage) {
    isUser = false;
  } else {
    isUser = true;
  }

  return {
    props: {
      isUser,
      ...(await serverSideTranslations(ctx.locale, ["common", "favourites"])),
    },
  };
}
